module.exports = __webpack_public_path__ + "static/img/yz2.6242ebd5.png";